import { render, staticRenderFns } from "./SentTable.vue?vue&type=template&id=5db6bd6b&"
import script from "./SentTable.vue?vue&type=script&lang=js&"
export * from "./SentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports